import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import NavbarMob from "./NavbarMob";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Navbar2 from "./Navbar2";
import Select from "react-select"; // Importing react-select
import statesAndDistricts2 from "../json/states-and-districts.json";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Navbar2Mob from "./Navbar2Mob";

function CandidateReg() {
    const [companyDistrict, setCompanyDistrict] = useState("");
    const [districtOptions, setDistrictOptions] = useState([]);
    const [candidateDegree, setCandidateDegree] = useState("");
    const [degreeOptions, setDegreeOptions] = useState([]);
    const [jobsCategory, setJobsCategory] = useState("");
    const [jobsOptions, setJobsOptions] = useState([]);
    const [locationData, setLocationData] = useState(null);
    const [jobsData, setJobsData] = useState(null);
    const [qualificationData, setQualificationData] = useState(null);
    const [locationCategory2, setLocationCategory2] = useState("");

    const [locationCategory, setLocationCategory] = useState("");
    const [locationOptions, setLocationOptions] = useState([]);
    const [name, setName] = useState("");
    const [houseName, setHouseName] = useState("");
    const [experienced, setExperienced] = useState("");

    const [exactLocation, setExactLocation] = useState("");
    const [bigTown, setBigTown] = useState("");

    const [age, setAge] = useState("");
    const [famNumber, setFamNumber] = useState("");

    const [mobile, setMobile] = useState("");
    const [whatsapp, setWhatsapp] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [gender, setGender] = useState(null);
    const [jobType, setJobType] = useState(null);
    const [maritalStatus, setMartialStatus] = useState(null);
    const [maxJobsLimit, setMaxJobsLimit] = useState(7);
    const [maxLocationLimit, setMaxLocationLimit] = useState(5);
    const [newJobsLimit, setNewJobsLimit] = useState("");
    const [newLocationLimit, setNewLocationLimit] = useState("");
    const customerType = sessionStorage.getItem("customerType");

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();

    const handleGenderChange = (selectedOption) => {
        setGender(selectedOption ? selectedOption.value : null);
    };

    const handleJobTypeChange = (selectedOption) => {
        setJobType(selectedOption ? selectedOption.value : null);
    };

    const handleMaritalStatusChange = (selectedOption) => {
        setMartialStatus(selectedOption ? selectedOption.value : null);
    };

    const fetchLocationData = async () => {
        try {
            const response = await fetch(`${apiBaseUrl}/data`);
            if (response.ok) {
                const data = await response.json();
                setLocationData(data);
            } else {
                console.error("Failed to fetch location data:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching location data:", error);
        }
    };

    useEffect(() => {
        fetchLocationData();
    }, []);

    useEffect(() => {
        if (locationData) {
            const locations = locationData.states[0].districts
                .filter((district) => district !== "All Kerala")
                .map((district) => ({
                    value: district,
                    label: district,
                }));
            setLocationOptions(locations);
        }
    }, [locationData]);

    const fetchJobsData = async () => {
        try {
            const response = await fetch(`${apiBaseUrl}/datajobs`);
            if (response.ok) {
                const data = await response.json();
                setJobsData(data);
            } else {
                console.error("Failed to fetch jobs data:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching jobs data:", error);
        }
    };

    useEffect(() => {
        fetchJobsData();
    }, []);

    useEffect(() => {
        if (!jobsData?.states?.[0]?.jobs) return; // ← changed from districts to jobs

        const opts = jobsData?.states?.[0]?.jobs?.map((job) => ({
            value: job,
            label: job,
        })) || [];
        setJobsOptions(opts);
    }, [jobsData]);

    const fetchQualificationData = async () => {
        try {
            const response = await fetch(`${apiBaseUrl}/dataqualifications`);
            if (response.ok) {
                const data = await response.json();
                setQualificationData(data);
            } else {
                console.error("Failed to fetch qualification data:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching qualification data:", error);
        }
    };

    useEffect(() => {
        fetchQualificationData();
    }, []);

    useEffect(() => {
        if (qualificationData) {
            const degrees = qualificationData.states[0].districts.map((district) => ({
                value: district,
                label: district,
            }));
            setDegreeOptions(degrees);
        }
    }, [qualificationData]);

    useEffect(() => {
        window.scrollTo(0, 0);

        const districts = statesAndDistricts2.states[0].districts.map((district) => ({
            value: district,
            label: district,
        }));

        setDistrictOptions(districts);
    }, []);

    const handleDistrictChange = (selectedOption) => {
        setCompanyDistrict(selectedOption ? selectedOption.value : "");
    };

    const handleDegreeChange = (selectedOption) => {
        setCandidateDegree(selectedOption ? selectedOption.value : "");
    };

    const handleLocationChange2 = (selectedOption) => {
        setLocationCategory2(selectedOption ? selectedOption.value : "");
    };

    useEffect(() => {
        fetch(`${apiBaseUrl}/api/getPreferencesLimits`)
            .then((response) => response.json())
            .then((data) => {
                setMaxJobsLimit(data.job_preference_limit);
                setMaxLocationLimit(data.location_preference_limit);
            })
            .catch((error) => console.error("Error fetching limits:", error));
    }, [apiBaseUrl]);

    const handleJobsChange = (selectedOptions) => {
        if (selectedOptions.length <= maxJobsLimit) {
            setJobsCategory(selectedOptions);
        } else {
            alert(`You can select a maximum of ${maxJobsLimit} options`);
        }
    };

    const handleLocationChange = (selectedOptions) => {
        if (selectedOptions.length <= maxLocationLimit) {
            setLocationCategory(selectedOptions);
        } else {
            alert(`You can select a maximum of ${maxLocationLimit} options`);
        }
    };

    const handleUpdateLimits = () => {
        if (!newJobsLimit || !newLocationLimit) {
            alert("Please enter valid limits for both fields.");
            return;
        }

        fetch(`${apiBaseUrl}/api/updatePreferencesLimits`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                jobPreferenceLimit: parseInt(newJobsLimit),
                locationPreferenceLimit: parseInt(newLocationLimit),
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                alert(data.message);
                setMaxJobsLimit(parseInt(newJobsLimit));
                setMaxLocationLimit(parseInt(newLocationLimit));
                setNewJobsLimit("");
                setNewLocationLimit("");
            })
            .catch((error) => console.error("Error updating limits:", error));
    };

    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const jobTypeOptions = [
        { value: "any", label: "Any" },
        { value: "fulltime", label: "Full-time" },
        { value: "parttime", label: "Part-time" },
        { value: "remote", label: "Remote/Work at Home" },
    ];

    const genderOptions = [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "other", label: "Other" },
    ];

    const maritalStatusOptions = [
        { value: "single", label: "Single" },
        { value: "married", label: "Married" },
        { value: "divorced", label: "Divorced" },
        { value: "widow", label: "Widow" },
    ];

    const customStyles = {
        control: (base) => ({
            ...base,
            height: "43px",
            borderRadius: "5px",
            border: "2px solid #D7D7D7",
            paddingLeft: "4px",
        }),
    };

    const customStyles2 = {
        control: (base) => ({
            ...base,
            height: "43px",
            borderRadius: "5px",
            border: "2px solid #D7D7D7",
            paddingLeft: "4px",
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: "#E0E0E0",
            borderRadius: "3px",
            padding: "2px 6px",
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: "black",
            fontSize: "12px",
        }),
        multiValueRemove: (base) => ({
            ...base,
            cursor: "pointer",
            ":hover": {
                backgroundColor: "#D7D7D7",
                color: "red",
            },
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    };

    // Helper to clean phone number (strips non-digits, removes country code, enforces 10 digits)
    const cleanPhoneNumber = (value, fieldName) => {
        // Remove all non-digits
        let cleaned = value.replace(/\D/g, "");

        // Remove common country codes (e.g., +91, 91) from the start
        if (cleaned.startsWith("91") || cleaned.startsWith("971")) {
            cleaned = cleaned.slice(2); // Remove first 2 digits if it's a country code
        } else if (cleaned.startsWith("1")) {
            // e.g., +1 for US
            cleaned = cleaned.slice(1);
        }

        // Enforce exactly 10 digits
        if (cleaned.length < 10) {
            alert(`Include country code in ${fieldName}`);
            return null;
        }

        if (cleaned.length > 10) {
            alert(`Check ${fieldName} again`);
            return null;
        }

        return cleaned;
    };

    const handleSubmit = async () => {
        // === MANDATORY FIELDS CHECK ===
        const requiredFields = {
            name: "Name",
            houseName: "House Name",
            age: "Age",
            mobile: "Mobile Number",
            whatsapp: "WhatsApp Number",
            // famNumber: "Father/Husband Number",
            password: "Password",
            gender: "Gender",
            bigTown: "Near Big Town",
            // exactLocation: "Proper Place / Exact Location",
            maritalStatus: "Marital Status",
        };

        for (const [key, label] of Object.entries(requiredFields)) {
            const value = eval(key);
            if (!value || (typeof value === "string" && value.trim() === "")) {
                alert(`Please fill: ${label}`);
                return;
            }
        }

        // Clean phone numbers before submit
        const cleanedMobile = cleanPhoneNumber(mobile, "Mobile Number");
        const cleanedWhatsapp = cleanPhoneNumber(whatsapp, "WhatsApp Number");
        // const cleanedFamNumber = cleanPhoneNumber(famNumber, "Father/Husband Number");

        if (!cleanedMobile || !cleanedWhatsapp ) {
            return; // Alert already shown in cleanPhoneNumber
        }

        // Prevent Father/Husband from matching Mobile or WhatsApp
        // if (cleanedFamNumber === cleanedMobile || cleanedFamNumber === cleanedWhatsapp) {
        //     alert("Father/Husband number cannot be the same as Mobile or WhatsApp");
        //     return;
        // }

        // Password minimum length
        if (password.length < 4) {
            alert("Password must be at least 4 characters");
            return;
        }

        // Check if mobile is blocked (using cleaned mobile)
        try {
            const blockedRes = await fetch(`${apiBaseUrl}/getBlockedProfiles`);
            const blocked = await blockedRes.json();
            const isBlocked = blocked.some((p) => p.ProfileType === "candidate" && p.MobileNumber === cleanedMobile);
            if (isBlocked) {
                alert("This mobile number is blocked. Contact admin.");
                return;
            }
        } catch (err) {
            console.error("Block check failed", err);
        }

        // Prepare data with cleaned numbers
        const data = {
            name: name.trim(),
            houseName: houseName.trim(),
            age: parseInt(age),
            mobile: cleanedMobile,
            whatsapp: cleanedWhatsapp,
            // famNumber: cleanedFamNumber,
            password,
            gender,
            bigTown: bigTown.trim(),
            exactLocation: exactLocation.trim(),
            maritalStatus,
            email: email.trim() || null,
            district: companyDistrict || null,
            degree: candidateDegree || null,
            jobType: jobType || null,
            jobs: jobsCategory.length > 0 ? jobsCategory.map((o) => o.value) : [],
            locations: locationCategory.length > 0 ? locationCategory.map((o) => o.value) : [],
            experienced: experienced.trim() || null,
        };

        // console.log(data)

        try {
            const response = await fetch(`${apiBaseUrl}/registerCandidate`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            });

            const result = await response.json();

            if (!response.ok) {
                if (result.message?.includes("already exists")) {
                    alert("This mobile number is already registered");
                } else {
                    alert(result.message || "Registration failed");
                }
                return;
            }

            alert("Registration Successful! Welcome!");

            // Reset only mandatory fields
            setName("");
            setHouseName("");
            setAge("");
            setMobile("");
            setWhatsapp("");
            setFamNumber("");
            setPassword("");
            setGender(null);
            setBigTown("");
            setExactLocation("");
            setMartialStatus(null);

            navigate("/login");
        } catch (error) {
            console.error(error);
            alert("Network error. Please try again.");
        }
    };

    const login = () => {
        navigate("/login");
    };

    const terms = () => {
        navigate("/terms");
    };

    const Mandatory = () => <span className="text-red-600 font-bold ml-1">*</span>;

    return (
        <div className="flex flex-col min-h-screen">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="md:flex hidden">
                <Navbar2 />
            </div>
            <div className="md:hidden flex flex-col">
                <Navbar2Mob />
            </div>
            <div className="flex justify-center items-center bg-[black] py-12">
                <div className="lg:w-[80%] w-[90%] h-[70%] flex flex-col items-center bg-[white] gap-12 py-12 lg:rounded-[20px] rounded-[5px]">
                    <span className="text-xl font-[700] font-display">Candidate Register</span>
                    <div className="grid lg:grid-cols-3 grid-cols-1 gap-5 lg:px-12 px-3 w-full lg:pb-0 pb-2">
                        <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                Name ( പേര് )
                                <Mandatory />
                            </span>
                            <input
                                type="text"
                                placeholder="Enter Full Name"
                                // placeholder="പേര്"
                                className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                        <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                House Name ( വീട്ടുപേര് )
                                <Mandatory />
                            </span>
                            <input
                                type="text"
                                placeholder="Enter House Name"
                                // placeholder="വീട്ടുപേര്"
                                className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                value={houseName}
                                onChange={(e) => setHouseName(e.target.value)}
                            />
                        </div>
                        <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                Age ( വയസ്സ് )
                                <Mandatory />
                            </span>
                            <input
                                type="number"
                                placeholder="Enter Your Age"
                                // placeholder="വയസ്സ്"
                                className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                value={age}
                                onChange={(e) => setAge(e.target.value)}
                            />
                        </div>
                        <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                Mobile Number ( മൊബൈൽ നമ്പർ )
                                <Mandatory />
                            </span>
                            <input
                                type="text" // Changed to text for easy pasting
                                // placeholder="+91 9544500746"
                                placeholder="Enter Mobile Number"
                                // placeholder="മൊബൈൽ നമ്പർ"
                                className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                            />
                        </div>
                        <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                Whatsapp Number ( വാട്സ്ആപ്പ് നമ്പർ )
                                <Mandatory />
                            </span>
                            <input
                                type="text" // Changed to text for easy pasting
                                // placeholder="+91 9544500746"
                                placeholder="Enter Whatsapp Number"
                                // placeholder="വാട്സ്ആപ്പ് നമ്പർ"
                                className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                value={whatsapp}
                                onChange={(e) => setWhatsapp(e.target.value)}
                            />
                        </div>
                        {/* <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">Email ( ഇമെയിൽ )</span>
                            <input
                                type="text"
                                placeholder="Enter Email Address"
                                // placeholder="ഇമെയിൽ"
                                className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div> */}
                        <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                Create Password ( പാസ്സ്‌വേർഡ് ‌)
                                <Mandatory />
                            </span>
                            <div className="relative">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Create Password"
                                    // placeholder="പാസ്സ്‌വേർഡ്‌"
                                    className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4 pr-10"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <span
                                    className="absolute right-3 top-3 cursor-pointer text-gray-500"
                                    onClick={togglePasswordVisibility}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                        </div>
                        <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                Gender ( ബോയ് / ഗേൾ )
                                <Mandatory />
                            </span>
                            <Select
                                options={genderOptions}
                                isClearable={true}
                                placeholder="Select Gender"
                                // placeholder="ബോയ് / ഗേൾ"
                                classNamePrefix="react-select"
                                styles={customStyles}
                                value={genderOptions.find((option) => option.value === gender) || null}
                                onChange={handleGenderChange}
                            />
                        </div>
                        {/* <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">District ( ജില്ല )</span>
                            <Select
                                options={districtOptions}
                                onChange={handleDistrictChange}
                                placeholder="Select District"
                                // placeholder="ജില്ല"
                                className="w-full"
                                classNamePrefix="select"
                                isClearable={true}
                                value={districtOptions.find((option) => option.value === companyDistrict) || null}
                                styles={customStyles}
                            />
                        </div> */}
                        {/* <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                Near Big Town
                                ( അടുത്തുള്ള വലിയ ടൗൺ ന്റെ പേര് )
                                <Mandatory />
                            </span>
                            <input
                                type="text"
                                placeholder="Enter Near Big Town"
                                // placeholder="അടുത്തുള്ള വലിയ ടൗൺ ന്റെ പേര്"
                                className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                value={bigTown}
                                onChange={(e) => setBigTown(e.target.value)}
                            />
                        </div> */}
                        {/* <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                Proper Place ( വീട് നിൽക്കുന്ന സ്ഥലം )
                                <Mandatory />
                            </span>
                            <input
                                type="text"
                                placeholder="Enter Exact Location"
                                // placeholder="വീട് നിൽക്കുന്ന സ്ഥലം"
                                className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                value={exactLocation}
                                onChange={(e) => setExactLocation(e.target.value)}
                            />
                        </div> */}
                        {/* <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">Highest Qualification</span>
                            <Select
                                options={degreeOptions}
                                onChange={handleDegreeChange}
                                placeholder="Select Qualification"
                                className="w-full"
                                classNamePrefix="select"
                                isClearable={true}
                                value={degreeOptions.find((option) => option.value === candidateDegree) || null}
                                styles={customStyles}
                            />
                        </div> */}
                        {/* <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">Job Type</span>
                            <Select
                                options={jobTypeOptions}
                                isClearable={true}
                                placeholder="Select Job Type"
                                classNamePrefix="react-select"
                                styles={customStyles}
                                value={jobTypeOptions.find((option) => option.value === jobType) || null}
                                onChange={handleJobTypeChange}
                            />
                        </div> */}
                        {/* <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                Any Experience ( എക്സ്പീരിയൻസ് )
                            </span>
                            <input
                                type="text"
                                placeholder="Enter Experience"
                                // placeholder="എക്സ്പീരിയൻസ്"
                                className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                value={experienced}
                                onChange={(e) => setExperienced(e.target.value)}
                            />
                        </div> */}
                        <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                Marital Status ( വിവാഹ സ്റ്റാറ്റസ് )
                                <Mandatory />
                            </span>
                            <Select
                                options={maritalStatusOptions}
                                isClearable={true}
                                placeholder="Select Marital Status"
                                // placeholder="വിവാഹ സ്റ്റാറ്റസ്"
                                classNamePrefix="react-select"
                                styles={customStyles}
                                value={maritalStatusOptions.find((option) => option.value === maritalStatus) || null}
                                onChange={handleMaritalStatusChange}
                            />
                        </div>

                        <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                Near Big Town ( അടുത്തുള്ള വലിയ ടൗൺ ന്റെ പേര് )
                                <Mandatory />
                            </span>
                            <input
                                type="text"
                                placeholder="Enter Near Big Town"
                                // placeholder="അടുത്തുള്ള വലിയ ടൗൺ ന്റെ പേര്"
                                className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                value={bigTown}
                                onChange={(e) => setBigTown(e.target.value)}
                            />
                        </div>

                        <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                Father/Husband Mobile Number (വീട്ടിലെ മൊബൈൽ നമ്പർ)
                                {/* <Mandatory /> */}
                            </span>
                            <input
                                type="text" // Changed to text for easy pasting
                                // placeholder="+91 7356400746"
                                placeholder="Enter Father/Husband Number"
                                // placeholder="വീട്ടിലെ മൊബൈൽ നമ്പർ"
                                className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                value={famNumber}
                                onChange={(e) => setFamNumber(e.target.value)}
                            />
                        </div>

                        {/* <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                Job Location{" "}
                                <span className="text-[#E22E37] text-base font-[500] font-display">
                                    (Max-{maxLocationLimit})
                                </span>
                            </span>
                            <Select
                                options={locationOptions}
                                onChange={handleLocationChange}
                                placeholder="Select Location"
                                className="w-full"
                                classNamePrefix="select"
                                isClearable={true}
                                isMulti
                                value={locationCategory}
                                styles={customStyles2}
                            />
                        </div> */}
                        {/* <div className="flex flex-col gap-3">
                            <span className="text-left text-base font-[500] font-display">
                                Job Preference{" "}
                                <span className="text-[#E22E37] text-base font-[500] font-display">
                                    (Max-{maxJobsLimit})
                                </span>
                            </span>
                            <Select
                                options={jobsOptions}
                                onChange={handleJobsChange}
                                placeholder="Select"
                                className="w-auto"
                                classNamePrefix="select"
                                isClearable={true}
                                isMulti
                                value={jobsCategory}
                                styles={customStyles2}
                            />
                        </div> */}
                    </div>

                    {customerType === "mainAdmin" && (
                        <div className="w-full flex flex-col gap-3 justify-start items-start lg:px-12 px-3">
                            <h2 className="text-lg font-semibold">Update Selection Limits</h2>
                            <label>
                                Job Limit:
                                <input
                                    type="number"
                                    value={newJobsLimit}
                                    onChange={(e) => setNewJobsLimit(e.target.value)}
                                    className="border rounded px-2 py-1"
                                />
                            </label>
                            <label>
                                Location Limit:
                                <input
                                    type="number"
                                    value={newLocationLimit}
                                    onChange={(e) => setNewLocationLimit(e.target.value)}
                                    className="border rounded px-2 py-1"
                                />
                            </label>
                            <button onClick={handleUpdateLimits} className="bg-blue-500 text-white px-4 py-2 rounded mt-3">
                                Update Limits
                            </button>
                        </div>
                    )}

                    <div className="flex flex-col gap-5 w-full px-12 justify-center items-center">
                        <span className="text-base font-[300] font-display">
                            By submitting you agree to our{" "}
                            <span
                                className="text-base font-[400] font-display text-[blue] cursor-pointer hover:text-[black]"
                                onClick={terms}
                            >
                                Terms & Conditions
                            </span>{" "}
                        </span>

                        <div
                            className="h-[56px] lg:w-[25%] w-[50%] bg-[#E22E37] rounded-[20px] flex justify-center items-center text-[white] text-lg font-display font-[600] cursor-pointer hover:bg-[black] hover:text-[white]"
                            onClick={handleSubmit}
                        >
                            Register
                        </div>
                        <span className="text-base font-[500] font-display">
                            Already Registered? -{" "}
                            <span
                                className="text-base font-[700] font-display text-[#E22E37] cursor-pointer hover:text-[black]"
                                onClick={login}
                            >
                                Login
                            </span>{" "}
                        </span>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default CandidateReg;
